import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  Icon,
  IconSize,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { useTranslation } from 'react-i18next';

interface NetworkHolderDetailsProps {
  holder: GatewayNetworkModel['holder'];
}

export const NetworkHolderDetailsView = ({
  holder,
}: NetworkHolderDetailsProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Card gap={GapEnum.L}>
      <AccentTitle
        as={HeadingEnum.H2}
        icon="receipt-check"
        variant={AccentVariantEnum.Accent1}
        text={t('delmonicos-shared-sdk.outputs-network.holder')}
      />
      <Stack gap={GapEnum.S}>
        <Stack flex={1} gap={GapEnum.XS} alignItems="center">
          <Icon name="building-01" iconSize={IconSize.Small} />
          <Text fontSize={TextFontSize.Small} uppercase>
            {t('delmonicos-shared-sdk.outputs-holder.company-name')}
          </Text>
        </Stack>
        <Stack flex={1}>
          <span>{holder.companyName}</span>
        </Stack>
      </Stack>
      <Stack gap={GapEnum.S} flex={1}>
        <Stack flex={1}>
          <Text fontSize={TextFontSize.Small} uppercase>
            <Stack gap={GapEnum.XS} alignItems="center">
              <Icon name="marker-pin-04" iconSize={IconSize.Small} />
              {t('delmonicos-shared-sdk.outputs-holder.last-name')} -{' '}
              {t('delmonicos-shared-sdk.outputs-holder.first-name')}
            </Stack>
          </Text>
        </Stack>
        <Stack flex={1}>
          <span>
            {holder.lastName} - {holder.firstName}
          </span>
        </Stack>
      </Stack>
      <Stack gap={GapEnum.S}>
        <Stack flex={1} gap={GapEnum.XS} alignItems="center">
          <Icon name="mail-01" iconSize={IconSize.Small} />
          <Text fontSize={TextFontSize.Small} uppercase>
            {t('delmonicos-shared-sdk.outputs-holder.email')}
          </Text>
        </Stack>
        <Stack flex={1}>
          <span>{holder.email}</span>
        </Stack>
      </Stack>
      <Stack gap={GapEnum.S}>
        <Stack flex={1} gap={GapEnum.XS} alignItems="center">
          <Icon name="marker-pin-01" iconSize={IconSize.Small} />
          <Text fontSize={TextFontSize.Small} uppercase>
            {t('delmonicos-shared-sdk.outputs-holder.address')}
          </Text>
        </Stack>
        <Stack flex={1}>
          <span>
            {holder.address.address}, {holder.address.zipCode}{' '}
            {holder.address.city} - {holder.address.countryCode}
          </span>
        </Stack>
      </Stack>
      <Stack gap={GapEnum.S}>
        <Stack flex={1} gap={GapEnum.XS} alignItems="center">
          <Icon name="building-01" iconSize={IconSize.Small} />
          <Text fontSize={TextFontSize.Small} uppercase>
            {t('delmonicos-shared-sdk.outputs-holder.siret')}
          </Text>
        </Stack>
        <Stack flex={1}>
          <span>{holder.siret}</span>
        </Stack>
      </Stack>
      <Stack gap={GapEnum.S}>
        <Stack flex={1} gap={GapEnum.XS} alignItems="center">
          <Icon name="building-01" iconSize={IconSize.Small} />
          <Text fontSize={TextFontSize.Small} uppercase>
            {t('delmonicos-shared-sdk.outputs-holder.vat-number')}
          </Text>
        </Stack>
        <Stack flex={1}>
          <span>{holder.vatNumber}</span>
        </Stack>
      </Stack>
    </Card>
  );
};
